export default "__VITE_ASSET__Ilg_yp4F__"